import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'om-input',
  templateUrl: './om-input.component.html',
  styleUrls: ['./om-input.component.scss']
})
export class OmInputComponent implements OnInit, OnChanges {
  @Input() control: FormControl;
  @Input() placeholder = '';

  @Input() class: string = 'w-full';
  @Input() label: string;
  @Input() icon: string;
  @Input() options: any[];
  @Input() showError = true;
  @Input() type = 'text';
  @Input() nzStatus = '';
  @Input() disabled = false;

  isRequired$ = new BehaviorSubject<boolean>(false);

  constructor() {}

  ngOnInit(): void {
    this.control = this.control ?? new FormControl('');
    this.updateIsRequired();
    if (this.disabled) {
      this.control.disable();
    }
    this.control.statusChanges.pipe(
      untilDestroyed(this),
      tap(() => this.updateIsRequired()),
    ).subscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.control && !changes.control.firstChange) {
      this.updateIsRequired();
    }
  }

  private updateIsRequired(): void {
    this.isRequired$.next(this.control.hasValidator(Validators.required));
  }
}
